import React from 'react';

export const Repeat: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg fill='none' stroke={color || 'currentColor'} strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' width={width || '1em'} height={height || '1em'} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <polyline points='23 4 23 10 17 10' />
        <polyline points='1 20 1 14 7 14' />
        <path d='M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15' />
    </svg>
);
